export default "__VITE_ASSET__CFmHGqU4__"